import _defineProperty from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Provides utilities for manipulating tree structures.
 *
 */
export var TreeRepositoryUtils = /*#__PURE__*/function () {
  function TreeRepositoryUtils() {
    _classCallCheck(this, TreeRepositoryUtils);
  }
  _createClass(TreeRepositoryUtils, null, [{
    key: "createRelationMaps",
    value:
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    function createRelationMaps(manager, metadata, alias, rawResults) {
      return rawResults.map(function (rawResult) {
        var _a;
        var joinColumn = metadata.treeParentRelation.joinColumns[0];
        var referencedColumn = (_a = joinColumn.referencedColumn) !== null && _a !== void 0 ? _a : metadata.primaryColumns[0];
        // fixes issue #2518, default to databaseName property when givenDatabaseName is not set
        var joinColumnName = joinColumn.givenDatabaseName || joinColumn.databaseName;
        var referencedColumnName = referencedColumn.givenDatabaseName || referencedColumn.databaseName;
        var id = rawResult[alias + "_" + referencedColumnName];
        var parentId = rawResult[alias + "_" + joinColumnName];
        return {
          id: manager.connection.driver.prepareHydratedValue(id, referencedColumn),
          parentId: manager.connection.driver.prepareHydratedValue(parentId, joinColumn)
        };
      });
    }
  }, {
    key: "buildChildrenEntityTree",
    value: function buildChildrenEntityTree(metadata, entity, entities, relationMaps, options) {
      var _a;
      var childProperty = metadata.treeChildrenRelation.propertyName;
      if (options.depth === 0) {
        entity[childProperty] = [];
        return;
      }
      var joinColumn = metadata.treeParentRelation.joinColumns[0];
      var referencedColumn = (_a = joinColumn.referencedColumn) !== null && _a !== void 0 ? _a : metadata.primaryColumns[0];
      var parentEntityId = referencedColumn.getEntityValue(entity);
      var childRelationMaps = relationMaps.filter(function (relationMap) {
        return relationMap.parentId === parentEntityId;
      });
      var childIds = new Set(childRelationMaps.map(function (relationMap) {
        return relationMap.id;
      }));
      entity[childProperty] = entities.filter(function (entity) {
        return childIds.has(referencedColumn.getEntityValue(entity));
      });
      entity[childProperty].forEach(function (childEntity) {
        TreeRepositoryUtils.buildChildrenEntityTree(metadata, childEntity, entities, relationMaps, _objectSpread(_objectSpread({}, options), {}, {
          depth: options.depth - 1
        }));
      });
    }
  }, {
    key: "buildParentEntityTree",
    value: function buildParentEntityTree(metadata, entity, entities, relationMaps) {
      var _a;
      var parentProperty = metadata.treeParentRelation.propertyName;
      var joinColumn = metadata.treeParentRelation.joinColumns[0];
      var referencedColumn = (_a = joinColumn.referencedColumn) !== null && _a !== void 0 ? _a : metadata.primaryColumns[0];
      var entityId = referencedColumn.getEntityValue(entity);
      var parentRelationMap = relationMaps.find(function (relationMap) {
        return relationMap.id === entityId;
      });
      var parentEntity = entities.find(function (entity) {
        if (!parentRelationMap) return false;
        return referencedColumn.getEntityValue(entity) === parentRelationMap.parentId;
      });
      if (parentEntity) {
        entity[parentProperty] = parentEntity;
        TreeRepositoryUtils.buildParentEntityTree(metadata, entity[parentProperty], entities, relationMaps);
      }
    }
  }]);
  return TreeRepositoryUtils;
}();